export default __webpack_public_path__ + "assets/106d4bdff5b501e2aafd0212e6ea9fe6.png";